<header-title [model]="headerTitle"></header-title>

<section class="card mt-4">
    <header class="card-header">
        <div class="card-header-icon">
            <i class="fas fa-tasks"></i>
        </div>
        <h3>Add New Lender</h3>
    </header>
    <div class="card-body py-5">
        <div class="container">
            <div class="tab-navigation">
                <nav>
                    <ul class="nav nav-pills">
                        <li class="nav-active">
                            <a class="nav-link">
                                <i class="fas fa-building" aria-hidden="true"></i>Lender Details
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <form *ngIf="addLenderFormGroup" (submit)="addLender()" [formGroup]="addLenderFormGroup">
                <section class="card">
                    <div class="card-body">
                        <error-message [errors]="errors"></error-message>
                        <h3 class="mt-5 text-info">Lender Details</h3>
                        <div class="row mt-3">
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label class="control-label text-info">
                                        Name
                                    </label>
                                    <input type="text" class="form-control" formControlName="name" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer class="panel-footer mt-3">
                        <div class="row">
                            <div class="col-12 text-right">
                                <button class="btn btn-info" type="button" (click)="onBack()">Back</button>
                                <button class="btn btn-success ml-1" type="submit" [disabled]="!addLenderFormGroup.valid">Save</button>
                            </div>
                        </div>
                    </footer>
                </section>
            </form>
        </div>
    </div>
</section>
